/** Mensajes ES para errores de Firebase Storage. Compartido por publicar / fotos de perfil. */
export function mensajeErrorStorage(err) {
  const c = err?.code || '';
  if (c === 'storage/unauthorized')
    return 'Sin permiso para subir archivos. Revisá que estés logueado y las reglas de Storage en Firebase.';
  if (c === 'storage/canceled') return 'Subida cancelada.';
  if (c === 'storage/quota-exceeded') return 'Se superó la cuota de almacenamiento del proyecto.';
  if (c === 'storage/retry-limit-exceeded')
    return 'La subida falló varias veces. Probá otra red o fotos más livianas.';
  if (c === 'storage/invalid-checksum') return 'El archivo llegó corrupto. Probá subir de nuevo.';
  return err?.message || 'Error al subir la imagen.';
}
